import React from "react";
import styled from "styled-components";
import { LfSubheadStyle } from "../TypographyStyle";

const Subhead = styled.h2`
  ${LfSubheadStyle}
`;

const LfSubhead = ({ children, className, id }) => {
  return (
    <Subhead id={id} className={className}>
      {children}
    </Subhead>
  );
};

export default LfSubhead;
